import { useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import HelpGuideModal from './HelpGuideModal';
import { HELP_GUIDE_SECTIONS, HelpGuideSection } from '../utils/helpGuides';

interface HelpGuideButtonProps {
  section: HelpGuideSection;
}

/**
 * The `?` next to a section title. Kept separate from <AdminSectionTitle> so
 * that component stays stateless; react-modal renders nothing while closed, so
 * the guides are only fetched once someone actually asks for them.
 */
const HelpGuideButton = ({ section }: HelpGuideButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        title="Ver las guías"
        aria-label={`Ver las guías de ${HELP_GUIDE_SECTIONS[section]}`}
        className="flex-shrink-0 text-primary-500 hover:text-primary-400 transition-colors"
      >
        <FiHelpCircle className="w-6 h-6" />
      </button>
      <HelpGuideModal section={section} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default HelpGuideButton;
